import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { screenReaderStyles } from '@paypalcorp/pp-react-screen-reader';
import { cx } from '@paypalcorp/pp-react-utils';
import * as styles from './styles.css';
export { styles as loadingSpinnerStyles };

var _excluded = ["as", "className", "inverse", "size", "screenReaderText"];
var SIZE_DEFAULT = 'sm';
var LoadingSpinner = function (_ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'p' : _ref$as,
    className = _ref.className,
    inverse = _ref.inverse,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? SIZE_DEFAULT : _ref$size,
    screenReaderText = _ref.screenReaderText,
    rest = _objectWithoutProperties(_ref, _excluded);
  var sizesStyleMap = {
    xs: styles.sizeXs,
    sm: styles.sizeSm,
    md: styles.sizeMd,
    lg: styles.sizeLg,
    xl: styles.sizeXl
  };
  if (!Object.keys(sizesStyleMap).includes(size)) {
    size = SIZE_DEFAULT;
  }
  var classNames = cx(styles.base, inverse && styles.inverse, sizesStyleMap[size], className);
  return /*#__PURE__*/React.createElement(as, _extends({
    className: classNames,
    "data-ppui-info": "loading-spinner_4.0.6__8.5.0"
  }, rest, {
    role: "alert"
  }), /*#__PURE__*/React.createElement("span", {
    className: screenReaderStyles.screenReader,
    "data-ppui": "true"
  }, screenReaderText));
};

export { LoadingSpinner };
